import { registerSW } from 'virtual:pwa-register';
import './styles.css';
import './access/passphrase-gate.css';
import { requirePassphraseAccess } from './access/PassphraseGate';
import { startPwaInstallPromptCapture } from './pwa/PwaInstallPrompt';

registerSW({ immediate: true });
startPwaInstallPromptCapture();

async function startApplication(): Promise<void> {
  await requirePassphraseAccess();

  const { createGame } = await import('./game/createGame');
  const game = createGame();

  window.addEventListener('pagehide', () => game.loop.sleep());
  window.addEventListener('pageshow', () => game.loop.wake());
}

void startApplication();
